import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row align-items-center py-4" }
const _hoisted_2 = { class: "col-lg-6 col-7" }
const _hoisted_3 = { class: "h2 text-white d-inline-block mb-0" }
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "d-none d-md-inline-block ml-md-4"
}
const _hoisted_5 = { class: "container-fluid mt--5" }
const _hoisted_6 = { class: "row justify-content-center px-xl-5 px-xxl-6 position-relative" }
const _hoisted_7 = {
  key: 0,
  class: "w-100 h-100 position-absolute retry-calldata-container d-flex justify-content-center align-items-center"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Intentar de nuevo ")
const _hoisted_9 = { class: "col-xl-6 col-mb-12 p-0" }
const _hoisted_10 = { class: "col-xl-6 col-mb-12 p-0" }
const _hoisted_11 = { class: "row px-xl-5 px-xxl-6" }
const _hoisted_12 = { class: "col-lg-12 p-0 position-relative" }
const _hoisted_13 = {
  key: 0,
  class: "channels-list py-3 px-2"
}
const _hoisted_14 = { class: "font-weight-bold mr-1" }

import { computed, defineAsyncComponent } from "vue";
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import BaseHeader from "@/components/BaseHeader.vue";
import indicatorVue from "./components/indicator.vue";
import callDataVue from "./components/callData.vue";
import { InterfacesColor, InterfaceId, InterfacesName } from "@/types/tickets";
import { Interfaces } from "@/types/tickets";
import userHistory from "./components/userHistory.vue";
import { CallDataModule } from "@/store/modules/CallData";
import { onMounted } from "vue";
import { env } from "@/config";

type ChannelsByInterface = {
	[k: string]: {
		name: string;
		channels: { name: string; value: string }[];
	};
};

// => Computed

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const typification = defineAsyncComponent(() =>
	env.DynamicTypification
		? import(
				/* webpackChunckName: "typification" */ "./components/DynamicTypification.vue"
		  )
		: import(
				/* webpackChunckName: "typification" */ "./components/typification.vue"
		  )
);

// => Types
const user = computed(() => CallDataModule.user);
const channels = computed<ChannelsByInterface>(
	() =>
		user?.value?.channels?.reduce((acc: ChannelsByInterface, curr) => {
			const int: InterfaceId = curr?.channel?.interface as InterfaceId;
			if (acc[int]) {
				acc[int].channels.push({
					name: curr?.channel?.name ?? "canal",
					value: curr.service_id,
				});
			} else {
				acc[int] = {
					name: InterfacesName[int],
					channels: [
						{
							name: curr?.channel?.name ?? "canal",
							value:
								int === "WHATSAPP_PUP"
									? curr.service_id.split("@")[0]
									: curr.service_id,
						},
					],
				};
			}
			return acc;
		}, {} as ChannelsByInterface) ?? {}
);
// => Methods
/* onBeforeMount(() => {
	CallDataModule.updateActiveCall();
}); */
onMounted(() => {
	setTimeout(() => {
		CallDataModule.updateActiveCall();
	}, 1000);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_result = _resolveComponent("el-result")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BaseHeader, { class: "pb-6" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$route.name), 1),
            _createElementVNode("nav", _hoisted_4, [
              _createVNode(RouteBreadcrumb)
            ])
          ]),
          _createVNode(indicatorVue)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_card, { class: "no-border-card" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            (_unref(CallDataModule).errorAlert)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_el_result, {
                    icon: "error",
                    title: "Error",
                    "sub-title": "No se ha podido rescatar la información de la llamada"
                  }, {
                    extra: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        onClick: _cache[0] || (_cache[0] = () => _unref(CallDataModule).updateActiveCall()),
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(callDataVue)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(typification))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (!_unref(env).onlyCallcenter && _unref(env).requiredCallcenter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(
									_unref(channels)
								), ([int, { name, channels: list }]) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: int,
                        class: "mx-1",
                        style: {"font-size":"1.1rem"}
                      }, [
                        _createVNode(_component_el_popover, {
                          trigger: "hover",
                          placement: "top",
                          title: name,
                          width: 300
                        }, {
                          reference: _withCtx(() => [
                            int
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(`${_unref(Interfaces)[int as InterfaceId]} text-${_unref(InterfacesColor)[int as InterfaceId]}`)
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (channel, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createElementVNode("small", _hoisted_14, _toDisplayString(channel.name) + ": ", 1),
                                  _createElementVNode("small", null, _toDisplayString(channel.value), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["title"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(userHistory)
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})